const words = ["Fun designs.", "Unique prints.", "Made with creativity.", "Custom prints welcome."];
const dots = ["var(--pink)", "var(--cyan)", "var(--lime)", "var(--yellow)"];

const Row = () => (
  <div className="flex items-center shrink-0">
    {words.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className="font-serif-i text-4xl sm:text-6xl px-6 sm:px-10 whitespace-nowrap">{w}</span>
        <span className="w-5 h-5 sm:w-7 sm:h-7 rounded-full border-2 border-[var(--paper)]" style={{ background: dots[i] }} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-hidden py-3 -my-3">
  <section data-testid="editorial-marquee" className="bg-[var(--ink)] text-[var(--paper)] py-5 sm:py-8 overflow-hidden border-y-2 border-[var(--ink)] -rotate-1 scale-[1.02]">
    <div className="flex w-max marquee-track">
      <Row /><Row /><Row /><Row />
    </div>
  </section>
  </div>
);
